import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import {useTheme} from '../../../theme/themeContext';
import {themes} from "../../../theme/themeContext/themes";
import {useFontSize} from "../FontSizeChange/FontSizeContext";

const useStyles = makeStyles((theme) => ({
    h4: {
        color: ({postsTextColor}) => postsTextColor,
        transition: "all 0.5s ease-out",
        fontSize: '28px',
        fontWeight: '700',
        fontFamily: 'Helvetica-Bold',
        marginBottom: '10px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '18px',
        }
    },
}));

const H4 = ({ children }) => {
    const { theme } = useTheme();
    const classes = useStyles(themes[theme]);


    return (
        <Typography variant="h4" className={classes.h4} id="myElementId" dangerouslySetInnerHTML={{__html: children}}/>
    );
};

export default H4;